import "./PinInput.scss";

import { FC, useState } from "react";
import OtpInput from "react-otp-input";

import Loader from "components/Loader/Loader";
import Text from "components/Text/Text";

import classNames from "classnames";

interface IProps {
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  error?: boolean;
  focus?: boolean;
  initialValue?: string;
  length?: number;
  message?: string;
  onChange?: (value: string) => void;
  onComplete?: (value: string) => void;
  secret?: boolean;
}

const Pin: FC<IProps> = props => {
  const {
    className,
    disabled,
    loading,
    error,
    focus,
    initialValue = "",
    length = 6,
    message,
    onChange,
    onComplete,
    secret,
  } = props;

  const [value, setValue] = useState(initialValue);

  const handleChange = (val: string) => {
    setValue(val);
    onChange?.(val);
    if (val.length === length) {
      onComplete?.(val);
    }
  };

  const classes = classNames(className, "pin", {
    "pin--error": error,
    disabled,
  });

  return (
    <div className={classes}>
      <OtpInput
        value={value}
        onChange={handleChange}
        numInputs={length}
        shouldAutoFocus={focus && !disabled && !loading}
        inputType={secret ? "password" : "tel"}
        containerStyle="pincode-input-container"
        inputStyle="pincode-input-text"
        renderInput={(props, index) => (
          <input
            {...props}
            disabled={disabled || loading}
            readOnly={disabled || loading}
            autoComplete={index === 0 ? "one-time-code" : "off"}
            aria-invalid={error}
            aria-label={`Digit ${index + 1} of ${length}`}
            aria-describedby={message ? "pin-message" : undefined}
            data-testid={`otp-input-${index}`}
          />
        )}
      />

      {message && <Text tag="p3" text={message} className="pin__message" id="pin-message" />}
      {loading && <Loader />}
    </div>
  );
};

export default Pin;
